import classNames from 'classnames'

import { ConfirmModal, ConfirmModalAction, ModalButton } from '@apps-common/components/modals'
import { COMMON_ICONS_TYPE, commonIcons } from '@apps-common/config/icons'

interface IProps {
  loading: boolean
  confirmProps?: {
    text: string
    description: string
    action: ConfirmModalAction
  }
  confirmCallback: () => void
  text: string
  icon: COMMON_ICONS_TYPE
  iconClasses?: string
  classes?: string
  reverseIcon?: boolean
}

export const ModalTopConfirmActionButton = ({
  loading,
  confirmProps,
  confirmCallback,
  text,
  icon,
  iconClasses,
  classes,
  reverseIcon
}: IProps) => {
  const Icon = commonIcons[icon]

  const body = reverseIcon ? (
    <>
      <div className=' w-[25px] h-[25px] rounded-full flex items-center justify-center'>
        <Icon className={iconClasses} />
      </div>
      {text}
    </>
  ) : (
    <>
      {text}
      <div className=' w-[25px] h-[25px] rounded-full flex items-center justify-center'>
        <Icon className={iconClasses} />
      </div>
    </>
  )

  return (
    <>
      {!confirmProps && (
        <button
          type='button'
          className={classNames(
            'flex items-center justify-center jost-light text-[0.8em] gap-[5px] !bg-surface text-text rounded-full px-1',
            classes,
            reverseIcon && 'pr-[5px]',
            !reverseIcon && 'pl-[5px]'
          )}
          disabled={loading}
          onClick={confirmCallback}
        >
          {body}
        </button>
      )}
      {confirmProps && (
        <ModalButton
          classes={classNames(
            'jost-light text-[0.8em] flex items-center justify-center gap-[0px] !bg-surface text-text rounded-full px-1',
            classes,
            reverseIcon && 'pr-[10px]',
            !reverseIcon && 'pl-[10px]'
          )}
          disabled={loading}
          component={ConfirmModal}
          componentProps={confirmProps}
          confirmCallback={confirmCallback}
        >
          {body}
        </ModalButton>
      )}
    </>
  )
}
